import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "d-flex flex-column flex-1"
  }, [_c('div', {
    staticClass: "d-flex flex-row login-main px-4 py-10"
  }, [_c('div', {
    staticClass: "d-flex flex-column login-container px-4 py-10"
  }, [!_vm.$vuetify.breakpoint.mdAndUp ? _c('div', {
    staticClass: "d-flex justify-center image-col align-self-center",
    style: {
      width: '150px'
    }
  }, [_c(VImg, {
    staticClass: "items",
    attrs: {
      "id": "placeholder-image",
      "src": require('@/assets/signup/Otto_WO_Bubble_M.svg')
    }
  })], 1) : _vm._e(), _c('uc-text', {
    staticClass: "my-2",
    attrs: {
      "text": 'We are happy you\'re back, sign in!',
      "data-cy": "login-header-text",
      "type": "title",
      "size": 1,
      "palette-color": "primary"
    }
  }), _c('div', {
    staticClass: "d-flex flex-row my-2"
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, _vm._l(3, function (i) {
    return _c(VSkeletonLoader, {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isIframeLoaded,
        expression: "!isIframeLoaded"
      }],
      key: i,
      class: i === 1 ? 'ml-0' : 'ml-4',
      attrs: {
        "width": "55px",
        "height": "45px",
        "type": "image"
      }
    });
  }), 1), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isIframeLoaded,
      expression: "isIframeLoaded"
    }],
    attrs: {
      "src": _vm.ssoRedirectURL,
      "referrerpolicy": "same-origin",
      "frameborder": "0",
      "height": "70px",
      "width": "100%"
    },
    on: {
      "load": _vm.onLoad
    }
  })]), _c('uc-phone-input', {
    ref: "phoneOrEmailRef",
    staticClass: "mt-2",
    attrs: {
      "data-cy": "login-user-name",
      "error-messages": _vm.phoneOrEmailErrorMessage,
      "label": _vm.EMAIL_OR_PHONE_REQ
    },
    on: {
      "blur": _vm.validateEmailOrPhone
    },
    model: {
      value: _vm.phoneOrEmail,
      callback: function ($$v) {
        _vm.phoneOrEmail = $$v;
      },
      expression: "phoneOrEmail"
    }
  }), _c('uc-input', {
    attrs: {
      "data-cy": "password-input",
      "label": 'Password',
      "label-variant": true,
      "rules": _vm.presenceRule,
      "required": true,
      "placeholder": "********",
      "type": 'password',
      "validate-on-blur": ""
    },
    on: {
      "keydown:enter": function ($event) {
        _vm.validPhoneOrEmail ? _vm.submitLogin() : null;
      }
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _c('div', {
    staticClass: "d-flex flex-row justify-space-between align-center"
  }, [_c('uc-checkbox', {
    staticClass: "flex-1 my-0",
    attrs: {
      "label": "Remember Me",
      "hide-details": ""
    },
    model: {
      value: _vm.rememberMe,
      callback: function ($$v) {
        _vm.rememberMe = $$v;
      },
      expression: "rememberMe"
    }
  }), _c('uc-button', {
    attrs: {
      "text": "Forgot Password",
      "type": "text"
    },
    on: {
      "click": function ($event) {
        return _vm.forgotPasswordModalRef.show();
      }
    }
  })], 1), _c('div', {
    staticClass: "d-flex flex-row align-center my-2"
  }, [_c('uc-text', {
    attrs: {
      "text": "Don't have an account?",
      "size": 3,
      "type": "body"
    }
  }), _c('uc-button', {
    attrs: {
      "text": "Sign up now",
      "type": "text",
      "size": "sm"
    },
    on: {
      "click": _vm.signUpNowHandler
    }
  })], 1), _c('div', {
    staticClass: "mt-2"
  }, [_c('uc-button', {
    staticClass: "d-flex submit-button",
    attrs: {
      "data-cy": "login-button",
      "text": _vm.password.length ? 'Login' : 'Login with OTP',
      "disabled": !_vm.validPhoneOrEmail
    },
    on: {
      "click": _vm.submitLogin
    }
  })], 1)], 1), _vm.$vuetify.breakpoint.mdAndUp ? _c('div', {
    staticClass: "d-flex justify-center align-self-center ml-8",
    style: {
      width: '350px'
    }
  }, [_c(VImg, {
    staticClass: "items",
    attrs: {
      "id": "placeholder-image",
      "src": require('@/assets/signup/003_SIGN_IN_424x424.svg')
    }
  })], 1) : _vm._e()]), _c('authorization-otp', {
    ref: "otpModalRef",
    attrs: {
      "header-text": _vm.phoneOrEmail,
      "error-messages": _vm.errorMessage
    },
    on: {
      "on-complete": _vm.submitCode,
      "resend-otp-action": function ($event) {
        return _vm.sendOTP('sign_in', true);
      },
      "reset-values": function ($event) {
        _vm.errorMessage = null;
      }
    }
  }), _c('authorization-forgot-password-modal', {
    ref: "forgotPasswordModalRef",
    attrs: {
      "phone-or-email": _vm.phoneOrEmail
    },
    on: {
      "resend-otp-action": _vm.forgotPasswordSendOTP
    }
  }), _c('authorization-forgot-password-update', {
    ref: "updatePasswordModalRef"
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };